import React from 'react';
import { useLocation } from 'react-router-dom';
import './VersionFooter.css';

const internalPaths = new Set([
  '/', '/login', '/dashboard', '/app-list', '/logs', '/legacy-logs',
  '/updates', '/notification-icon', '/font-preview',
]);

export default function VersionFooter() {
  const { pathname } = useLocation();
  if (!internalPaths.has(pathname.replace(/\/$/, '') || '/')) return null;

  return (
    <footer className="portal-version-footer" aria-label="Portal versions"
      title="Source versions included when this web portal was built">
      <span>Web {process.env.REACT_APP_WEB_VERSION}</span>
      <span aria-hidden="true">·</span>
      <span>Functions {process.env.REACT_APP_FUNCTIONS_VERSION}</span>
    </footer>
  );
}
